import { useRadio } from "./useRadio"
import react, { ReactNode } from 'react'

export interface IGlobalModalData {
  show: boolean,
  onClose: () => void,
  component: ReactNode
}

export interface IModalData {
  onClose: () => void,
  component: ReactNode
}

export function useModal() {
  const radio = useRadio();

  return {
    close: () => {
      radio.broadcast('global', { show: false, onClose: () => { } });

    }, open: (data: IModalData) => {

      radio.broadcast('global', { show: true, onClose: data.onClose, component: data.component });
    }
  }
}